import React from "react";
import useGameStore from "../store/gameStore";
import InteractiveTile from "./InteractiveTile";
import StartMenu from "./StartMenu";

function Grid() {
  const tiles = useGameStore((s) => s.tiles);
  const gameStatus = useGameStore((s) => s.gameStatus);

  return (
    <>
      {gameStatus === "menu" && <StartMenu />}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gridTemplateRows: "repeat(4, 1fr)",
          gap: "5px",
        }}
      >
        {tiles.map((tile) => (
          <InteractiveTile key={tile.id} tile={tile} />
        ))}
      </div>
    </>
  );
}

export default React.memo(Grid);
